export const changeMonth = (monthId) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_MONTH',
      monthId
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/months.js